import murmurhash from "murmurhash";
import { Calendar } from "../helpers/calendar/calendar";
import { getCalendarFilter } from "../helpers/utils";

class CalendarInt {
  constructor() {
    this.calendar = new Calendar();
  }

  hasCalendar(controller, type) {
    return (
      controller.state.currentUser != null &&
      (controller.state.impersonate == null ||
        controller.state.impersonate === controller.state.currentUser ||
        controller.state?.settings?.integrations_redirected
      ) &&
      ((type === "google" &&
        controller.state.settings?.integrations?.calendar_google) ||
        (type === "native" &&
          controller.state.settings?.integrations?.calendar_native))
    );
  }

  authorizeIntegration(controller, type, eventsCallback = () => {}, maxEvents = 1000) {
    const that = this;
    const isGoogle = type.includes("google");
    this.calendar.authorizeIntegration(controller, type, maxEvents, true, function (type, events, email) {
        eventsCallback(type, events, email);
        console.log("Auth events update");
        that.triggerUpdate(events, controller);
    });
  }

  retrieveCalendarEvents(
    controller,
    calendarTypes,
    forceUpdate,
    maxEvents = 1000,
  ) {
    return new Promise((resolve) => {
      this.retrieveCalendarEventsAction(
        controller,
        calendarTypes,
        forceUpdate,
        maxEvents,
      );
    });
  }

  async retrieveCalendarEventsAction(
    controller,
    calendarTypes,
    forceUpdate,
    maxEvents,
  ) {
    try {
      if (maxEvents <= 0 || Calendar === null) {
        return;
      }

      const state = controller.state;
      const that = this;
      if (
        state.impersonate != null &&
        state.impersonate !== state.currentUser &&
        !state?.settings?.integrations_redirected
      ) {
        return;
      }
      console.log("Reading calendar events");

      const toQuery = [];
      Object.values(calendarTypes).forEach((type) => {
        if (this.hasCalendar(controller, type)) {
          toQuery.push(type);
        }
      });

      if (toQuery.length > 0) {
        const s = state.settings;
        const calendarRefreshInterval =
          s != null && s.calendar_refresh_sec != null
            ? 1 * s.calendar_refresh_sec
            : 15 * 60;

        const integrationsChanged =
          this.lastKnownSettings != null &&
          (this.lastKnownSettings.calendar_google !=
            state.settings?.integrations.calendar_google ||
            this.lastKnownSettings.calendar_native !=
              state.settings?.integrations.calendar_native);

        const now = new Date().getTime() / 1000;
        if (
          state.lastCalendarQuery == null ||
          forceUpdate ||
          now - state.lastCalendarQuery > calendarRefreshInterval ||
          integrationsChanged
        ) {
          const calendarEvents = [];
          const queried = [];

          this.lastKnownSettings = JSON.parse(
            JSON.stringify(state.settings?.integrations),
          );

          Object.values(toQuery).forEach((type) => {
            if (type === "google") state.calendarLoginShown = true;

            const filter = getCalendarFilter(controller, type);
            this.calendar.pullEvents(
              controller,
              type,
              filter,
              maxEvents,
              integrationsChanged || forceUpdate,
              function (type, events) {
                console.log("Events update");
                if (!queried.includes(type)) queried.push(type);
                calendarEvents.push(...events);
                if (queried.length === toQuery.length) {
                  that.triggerUpdate(calendarEvents, controller);
                }
              },
            );
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  triggerUpdate(calendarEvents, controller) {
    const strEvents = JSON.stringify(calendarEvents);
    const hash = murmurhash.v3(strEvents, "1234");
    if (
        controller.state.calendarItemsChecksum == null ||
        controller.state.calendarItemsChecksum !== hash
    ) {
      console.log("Updating calendar events");
      //console.log(strEvents);
      controller.setState({
        //TODO: separate per calendar type?
        lastCalendarQuery: new Date().getTime() / 1000,
        calendarItems: strEvents,
        calendarItemsChecksum: hash,
      });
    }
  }
}

export default CalendarInt;
